export const parseDurationToSeconds = (duration: string): number => {
  const splitDuration = duration.split(':');
  if (splitDuration.length === 0) {
    return 0;
  }
  const hours = parseInt(splitDuration[0] ?? '0');
  const minutes = parseInt(splitDuration[1] ?? '0');
  const seconds = parseInt(splitDuration[2] ?? '0');
  return hours * 3600 + minutes * 60 + seconds;
};